<!--理财-->
<template>
	<div class="id">
		<van-tabs v-model="textActive" @change="onText" background="#000" title-active-color="#ffffff"
			title-inactive-color="#888" color="#dfdfdf">
			<van-tab v-for="(item, index) in textList" :key="index" :title="item.name">
			</van-tab>
		</van-tabs>

		<div class="boxTop">
			<div class="boxItem" @click="currency = true">
				<div class="boxCode"> {{ productInfo.title }} </div>
				<div class="boxAmount" :style="{ color: '#00f0ff' }">{{ productInfo.price }}</div>
				<div class="boxProportion" :style="{ color: productInfo.price_zf > 0 ? '#00f0ff' : '#ff4834' }">
					{{ productInfo.price_zf }}%
				</div>
			</div>
			<div class="boxItemS">
				<div class="boxText">
					<div>{{ $t('最高价') }}</div>
					<div>{{ productInfo.price_high }}</div>
				</div>
				<div class="boxText">
					<div>{{ $t('最低价') }}</div>
					<div>{{ productInfo.price_low }}</div>
				</div>
				<div class="boxText">
					<div>24H{{ $t('量') }}</div>
					<div>{{ productInfo['24hl'] }}k</div>
				</div>
				<div class="boxText">
					<div>24H{{ $t('交易额') }}</div>
					<div>{{ productInfo['24hjye'] }}b</div>
				</div>
			</div>
		</div>
		<div class="switch">
			<div v-for="(value, index) in productInfo.periodList" :key="index" @click="switchC(value, index)"
				:class="{ colost: swindex == index }">
				{{ value.value }}
			</div>
		</div>
		<keep-alive>
			<kLine ref="kLine" @close="getClose" :period="timeValue" :symbol="code" :price="productInfo.price"
				:high="productInfo.price_high" :low="productInfo.price_low" @market-update="handleMarketUpdate"></kLine>
		</keep-alive>
		<div v-show="textActive == 0" class="boxTb">
			<van-tabs v-model="actives" @change="onChangeS" background="#000" title-active-color="#ffffff"
				title-inactive-color="#888" color="#dfdfdf">
				<van-tab v-for="(item, index) in sourceS" :key="index" :title="item.name">
					<div class="scroll" v-if="orderListS.length > 0">
						<div v-for="value in orderListS" :key="value.id" class="boxS">
							<div class="boxItem">
								<div>{{ $t('产品') }}</div>
								<div>{{ value.product_title }}</div>
							</div>
							<div class="boxItem">
								<div>{{ $t('方向') }}</div>
								<div style="color: aqua;">{{ value.direction == 1 ? $t('买涨') : $t('买跌') }}</div>
							</div>
							<div class="boxItem">
								<div>{{ $t('开仓时间') }}</div>
								<div>{{ value.createtime_text }}</div>
							</div>
							<div class="boxItem">
								<div>{{ $t('开仓价') }}</div>
								<div>{{ value.open_price }}</div>
							</div>
							<div class="boxItem">
								<div>{{ $t('手续费') }}</div>
								<div>{{ value.fee }}</div>
							</div>
							<div class="boxItem">
								<div>{{ $t('平仓时间') }}</div>
								<div>{{ value.handletime_text }}</div>
							</div>
							<div class="boxItem">
								<div>{{ $t('平仓价') }}</div>
								<div>{{ value.end_price }}</div>
							</div>
							<div v-if="value.countdown > 0" class="boxItem">
								<div>{{ $t('倒计时') }}</div>
								<div>{{ value.countdown }}s</div>
							</div>
							<div class="boxItem">
								<div>{{ $t('金额') }}</div>
								<div>{{ value.amount }}（USDT）</div>
							</div>
							<div class="boxItem" :style="{ color: value.fact_profits > 0 ? '#00f0ff' : '#ff4834' }">
								<div>{{ $t('盈亏') }}</div>
								<div>{{ value.fact_profits }}（USDT）</div>
							</div>
						</div>
					</div>
					<van-empty :description="$t('暂无数据')" v-else />
				</van-tab>
			</van-tabs>
			<div style="height: 80px;"></div>
			<div class="contentS">
				<div @click="buyAndSell(1)">{{ $t('买涨') }}</div>
				<div @click="buyAndSell(2)">{{ $t('买跌') }}</div>
			</div>
		</div>
		<div v-show="textActive == 1" class="boxTb">
			<spotGoods ref="spotGoods" :productS="productInfo"></spotGoods>
		</div>

		<div v-show="textActive == 2" class="boxTb">
			<contract ref="childRef" :productS="productInfo"></contract>
		</div>
		<Footer></Footer>
		<van-popup v-model="showPopup" position="bottom" closeable close-icon="close" :style="{ height: '94%' }">
			<div class="popupId">
				<van-tabs v-model="activeCk" @change="onChangeCk" background="#12141e" title-active-color="#ffffff"
					title-inactive-color="#888" color="#dfdfdf">
					<van-tab v-for="(item, index) in source" :key="index" :title="item.name">
						<div class="interval">
							<div>{{ $t('交易区间') }}</div>
							<van-dropdown-menu>
								<van-dropdown-item v-model="intervalV" :options="intervalList" @change="changeS" />
							</van-dropdown-menu>
						</div>
						<div class="interval" @click="dataPopup = true" v-if="activeCk == 1">
							<div>{{ currentTime }}</div>
						</div>
						<div class="intervals">
							<van-field v-model="amount" :label="$t('投入金额') + '(USDT)'" :placeholder="$t('请输入')"
								label-width="130px" input-align="right" label-align="left" @input="inputCk">
							</van-field>
						</div>
						<!-- <div class="intervals" style="margin-top: 10px;">
							<van-field v-model="pay_password" :label="$t('资金密码')" :placeholder="$t('请输入')"
								label-width="130px" input-align="right" label-align="left">
							</van-field>
						</div> -->
						<div class="balance">
							<span>{{ $t('余额') }}</span>
							{{ moneyS }} USDT
						</div>
						<div>{{ $t('当前投资') }}</div>
						<div class="invest">
							<div class="item">
								<div>{{ $t('投资方向') }}</div>
								<div> {{ direction == 1 ? $t('买涨') : $t('买跌') }} </div>
							</div>
							<div class="item" style="justify-content: flex-end;">
								<div>{{ $t('投资收益率') }}</div>
								<div>{{ intervalObj.profit_ratio || 0 }}%</div>
							</div>
							<div class="item">
								<div>{{ $t('投资金额') }}</div>
								<div>{{ amountS }}USDT</div>
							</div>
							<div class="item" style="justify-content: flex-end;">
								<div>{{ $t('投资状态') }}</div>
								<div>{{ $t('暂无数据') }}</div>
							</div>
							<div class="item">
								<div>{{ $t('最低') }}</div>
								<div>{{ intervalObj.min || 0 }} USDT</div>
							</div>
							<div class="item" style="justify-content: flex-end;">
								<div>{{ $t('最高') }}</div>
								<div>{{ intervalObj.max || 0 }} USDT</div>
							</div>
						</div>
						<!-- <div class="invest" style="border-bottom: 1px solid #30313e;">
							<div class="item">
								<div>{{ $t('最低') }}</div>
								<div>{{ intervalObj.min || 0 }} USDT</div>
							</div>
							<div class="item" style="justify-content: flex-end;">
								<div>{{ $t('最高') }}</div>
								<div>{{ intervalObj.max || 0 }} USDT</div>
							</div>
						</div> -->
						<div class="btn" @click="orderSubmit()">
							<div>{{ $t('提交') }}</div>
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</van-popup>

		<van-popup v-model="dataPopup" position="bottom">
			<van-datetime-picker v-model="currentDate" type="datetime" :title="$t('选择时间')" @confirm="confirm"
				@cancel="dataPopup = false" :confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')" />
		</van-popup>

		<van-popup v-model="currency" position="left" closeable class="currencyId">
			<div class="currencyId">
				<div class="table">
					<!-- 表头 -->
					<van-row class="header">
						<van-col span="10" class="vanItem">{{ $t('币种') }}</van-col>
						<van-col span="7" class="vanItem">{{ $t('收盘价') }}</van-col>
						<van-col span="7" class="vanItem">{{ $t('市场交易') }}</van-col>
					</van-row>
					<!-- 数据 -->
					<div class="scroll">
						<van-row v-for="item in users" :key="item.id" class="row">
							<van-col span="10" class="rowItem">
								<van-image width="34" style="padding-left:6px;" :src="item.image" />
								<div style="padding-left: 12px;font-size: 12px;">
									<div>{{ item.symbol }}</div>
									<div style="padding-top: 6px;">{{ item.currency }}</div>
								</div>
							</van-col>
							<van-col span="7" style="text-align: center;">{{ item.open_price }}</van-col>
							<van-col span="7" class="trade">
								<div class="box" @click="trade(item)">{{ $t('交易') }}</div>
							</van-col>
						</van-row>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
	import {
		get,
		post
	} from '@/http/request'
	import apis from '@/http/api'
	import kLine from '@/common/mobile/kLine.vue'
	import Footer from '@/common/mobile/Footer.vue'
	import contract from './common/contract.vue'
	import spotGoods from './common/spotGoods.vue'
	export default {
		components: {
			kLine,
			Footer,
			contract,
			spotGoods
		},
		data() {
			return {
				actives: 0,
				currency: false,
				sourceS: [{
						name: this.$t('交割订单')
					},
					{
						name: this.$t('定时订单')
					},
					{
						name: this.$t('历史订单')
					}
				],
				textList: [{
						name: this.$t('期权')
					},
					{
						name: this.$t('现货')
					},
					{
						name: this.$t('合约')
					}
				],
				textActive: 0,
				amount: '',
				intervalV: 0,
				schedule: 0,
				dataPopup: false,
				currentTime: this.$t('选择时间'),
				currentDate: new Date(),
				marks: {
					0: '0%',
					25: '25%',
					50: '50%',
					75: '75%',
					100: '100%'
				},
				intervalList: [],
				showPopup: false,
				activeCk: 0,
				source: [{
						name: this.$t('立即交易')
					},
					{
						name: this.$t('定时交易')
					}
				],
				productInfo: {},
				code: 'BTC',
				timeValue: '1min',
				swindex: '0',
				showKLine: true,
				hasInitKLine: false,
				intervalObj: {},
				amountS: '0',
				moneyS: '',
				orderListS: [],
				users: [],
				direction: '',
				orderTimer: null,
				pay_password: '',
				countdownTimer: null // 定时器
			};
		},
		mounted() {
			this.code = this.$route.query.code || "BTC"

			//console.log(this.$route.query.id,'546545646');
			//this.textActive = Number(this.$route.query.id) || 0

			this.getProductInfo()
			this.getUserInfo()
			this.productList()
		},
		beforeDestroy() {
			if (this.orderTimer) clearTimeout(this.orderTimer);
			if (this.countdownTimer) clearInterval(this.countdownTimer);
		},
		methods: {
			handleMarketUpdate(msg) {
				console.log("📈 父组件接收到 market 数据:", msg);
				this.productInfo = {
					...this.productInfo,
					...msg || {}
				}
				// 在这里处理子组件传回的数据
			},
			buyAndSell(direction) {
				this.direction = direction
				this.showPopup = true
			},
			changeS(value) {
				this.intervalV = value
				this.intervalObj = this.intervalList.find(item => item.value === value)
			},

			trade(item) {
				console.log(item.symbol);
				this.code = item.symbol
				this.getProductInfo()
			},

			async productList() {
				const res = await get('/product/getProductList', {
					type: 1,
					title: this.value
				})
				if (res.code == 1) {
					console.log(res.data, '444');
					this.users = res.data
					return
				}
				this.$toast(res.msg);
			},
			//金额输入
			inputCk() {
				this.amountS = this.amount
			},
			onChangeS(name, title) {
				console.log("切换到", name, title)
				this.getOrderList()
			},

			onText() {
				// 调用同步方法
				// const result = this.$refs.childRef.hello("你好");
				// console.log(result);
				// 调用异步方法
				if (this.textActive == 0) {
					this.getUserInfo()
					this.getOrderList()
				}
				if (this.textActive == 1) {
					this.$refs.spotGoods.spotOrderList();
					this.$refs.spotGoods.getUserInfo();
					this.$refs.spotGoods.getUserSpot();
				}
				if (this.textActive == 2) {
					this.$refs.childRef.contractOrderList();
					this.$refs.childRef.getUserInfo();
				}
			},
			//获取数据
			getProductInfo() {
				this.$refs.kLine.openKline()
				get(this.$apis.getProductInfo, {
					code: this.code
				}).then(res => {
					if (res.code == 1) {
						this.productInfo = res.data
						this.intervalList = res.data.timeList.map(item => ({
							text: item.seconds + 's' + '-' + item.profit_ratio + '%',
							value: item.seconds,
							...item
						}))
						this.currency = false
						if (this.textActive == 0) {
							this.getOrderList()
						}
						if (this.textActive == 1) {
							this.$nextTick(() => {
								this.$refs.spotGoods.spotOrderList();
								this.$refs.spotGoods.getUserSpot();
							})
						}
						if (this.textActive == 2) {
							this.$nextTick(() => {
								this.$refs.childRef.contractOrderList();
							})
						}
					}
				})
			},

			//列表数据

			// async getOrderList() {
			// 	// 每次调用时，先清掉旧的定时器
			// 	if (this.orderTimer) {
			// 		clearTimeout(this.orderTimer);
			// 		this.orderTimer = null;
			// 	}
			// 	try {
			// 		let res = await get(apis.getOrderList, {
			// 			limit: 9999,
			// 			product_id: this.productInfo.id,
			// 			status: this.actives == 2 ? 3 : this.actives == 0 ? 1 : 0,
			// 			showLoading: false
			// 		});
			// 		if (res.code == 1) {
			// 			this.orderListS = res.data.list;
			// 		}
			// 	} catch (e) {
			// 		console.error("请求失败:", e);
			// 	} finally {
			// 		// 请求完成后重新开始 3 秒倒计时
			// 		this.orderTimer = setTimeout(() => {
			// 			this.getOrderList();
			// 		}, 3000);
			// 	}
			// },


			async getOrderList() {
				// 每次调用时，先清掉旧的接口轮询定时器
				if (this.orderTimer) {
					clearTimeout(this.orderTimer);
					this.orderTimer = null;
				}
				try {
					let res = await get(apis.getOrderList, {
						limit: 9999,
						product_id: this.productInfo.id,
						status: this.actives == 2 ? 3 : this.actives == 0 ? 1 : 0,
						showLoading: false
					});
					if (res.code == 1) {
						this.orderListS = res.data.list;

						// 1. 每次成功拿到新列表后，重启本地 1 秒倒计时
						this.startCountdown();
					}
				} catch (e) {
					console.error("请求失败:", e);
				} finally {
					// 请求完成后重新开始 3 秒倒计时（接口轮询）
					this.orderTimer = setTimeout(() => {
						this.getOrderList();
					}, 3000);
				}
			},

			// 本地 1 秒递减 countdown
			startCountdown() {
				// 先清除之前的秒级定时器
				if (this.countdownTimer) {
					clearInterval(this.countdownTimer);
					this.countdownTimer = null;
				}

				if (!this.orderListS || this.orderListS.length === 0) return;

				this.countdownTimer = setInterval(() => {
					this.orderListS.forEach(item => {
						// 如果 countdown 大于 0，每秒自减 1
						if (item.countdown && item.countdown > 0) {
							item.countdown--;
						}
					});
				}, 1000);
			},


			// k线
			getClose(e) {
				console.log(e)
			},
			onChangeCk(name, title) {
				console.log("切换到", name, title)
				if (name == 0) {
					this.currentTime = this.$t('选择时间')
				}
			},
			confirm(value) {
				this.currentTime = this.formatDateTime(value)
				this.dataPopup = false
			},
			//时间切换
			switchC(item, index) {
				this.timeValue = item.value
				this.swindex = index
			},
			//标题切换
			textC(index) {
				this.tCindex = index
			},

			//提交
			async orderSubmit() {
				let res = await post(apis.orderSubmit, {
					product_id: this.productInfo.id,
					direction: this.direction,
					seconds: this.intervalV,
					amount: this.amount,
					time: this.currentTime,
					type: this.activeCk,
					pay_password: this.pay_password
				})
				this.pay_password = ''
				if (res.code == 1) {
					this.$toast(res.msg);
					this.amount = ''
					this.showPopup = false
					setTimeout(() => {
						this.getUserInfo()
						this.getOrderList()
					}, 1000)
				}
			},
			//
			async getUserInfo() {
				const res = await get(apis.getUserInfo)
				if (res.code == 1) {
					this.moneyS = res.data.delivery_account
					return
				}
			},

			formatDateTime(dateStr) {
				const date = new Date(dateStr); // 解析 CST / ISO 格式时间
				const y = date.getFullYear();
				const m = String(date.getMonth() + 1).padStart(2, '0');
				const d = String(date.getDate()).padStart(2, '0');
				const hh = String(date.getHours()).padStart(2, '0');
				const mm = String(date.getMinutes()).padStart(2, '0');
				return `${y}-${m}-${d} ${hh}:${mm}`;
			}

		},
	};
</script>
<style lang="less" scoped>
	::v-deep .van-tabs__wrap {
		border-bottom: 1px solid #282838;
		padding-bottom: 5px;
	}


	.currencyId {
		width: 100%;
		height: 100%;
		background-color: #000;
		padding: 26px 10px;

		.table {
			background: #000;
			color: #fff;

			.header {
				font-weight: bold;
				background: #1c222c;
				padding: 14px 0;
				border-radius: 5px;

				.vanItem {
					text-align: center;
				}
			}

			.scroll {
				overflow-y: auto;
				height: 85vh;
				scrollbar-width: none;
				-ms-overflow-style: none;
			}

			.row {
				border-bottom: 1px solid #222b39;
				padding: 20px 10px;
				display: flex;
				align-items: center;


				.rowItem {
					display: flex;
					align-items: center;
				}

				.trade {
					text-align: right;

					.box {
						border: 1px solid #fff;
						padding: 5px 20px;
						border-radius: 5px;
						display: inline-block;
						font-size: 12px;
					}

				}
			}
		}
	}

	.popupId {
		background-color: #12141e;
		height: 94vh;
		padding: 26px 15px;

		.slider-wrap {
			padding: 35px 5px;
			padding-bottom: 0;

			/* 自定义滑块按钮 */
			.custom-button {
				position: relative;
				display: flex;
				flex-direction: column;
				align-items: center;

				/* 上方提示 */
				.tooltip {
					position: absolute;
					bottom: 130%;
					/* 在滑块上方 */
					background: #333;
					color: #fff;
					font-size: 12px;
					padding: 2px 6px;
					border-radius: 4px;
					white-space: nowrap;
				}

				/* 滑块点 */
				.dot {
					width: 20px;
					height: 20px;
					background-color: #1989fa;
					border-radius: 50%;
				}
			}

		}

		.btn {
			display: flex;
			justify-content: center;
			padding-top: 10px;

			div {
				width: 80%;
				text-align: center;
				color: #000;
				padding: 10px 0;
				font-size: 16px;
				border-radius: 10px;
				background-color: #00f0ff;
			}

		}

		.invest {
			padding-top: 24px;
			display: flex;
			flex-wrap: wrap;

			.item {
				width: 50%;
				margin-bottom: 20px;
				display: flex;
				align-items: center;

				div:nth-child(1) {
					color: #888;
					padding-right: 10px;
				}

			}
		}

		.markText {
			display: flex;
			justify-content: space-between;
			font-size: 12px;
			color: #666;
			margin-top: 10px;
			margin-right: -10px;
		}

		.balance {
			padding: 15px 0;
			font-size: 15px;

			span {
				padding-right: 10px;
				color: #888;
			}
		}

		.intervals {
			::v-deep .van-cell {
				color: #fff;
				border: 1px solid #2a2a3b;
				height: 50px;
				display: flex;
				align-items: center;
				border-radius: 5px;
			}
		}

		.interval {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border: 1px solid #2a2a3b;
			padding: 0 20px;
			margin: 15px 0;
			color: #888;
			border-radius: 5px;
			height: 50px;



			::v-deep .van-dropdown-menu__bar {
				background: #12141e;
			}

			::v-deep .van-dropdown-menu__title {
				color: #fff;
			}

			::v-deep .van-cell::after {
				border-bottom: 0px solid #000;
			}

			::v-deep .van-cell {
				color: #fff;
				border: 1px solid #2a2a3b;
				height: 50px;
				display: flex;
				align-items: center;
			}

			::v-deep .van-overlay {
				height: auto;
				background-color: #000;
			}

			::v-deep .van-field__label {
				color: #888;
			}
		}
	}

	.id {
		color: #fff;
		padding: 0 15px;
		padding-top: 50px;
		padding-bottom: 60px;
		font-size: 14px;
		position: relative;

		.boxTb {
			::v-deep .van-tabs__wrap {
				padding-bottom: 0px;
			}

			::v-deep .van-tabs__line {
				display: none !important;
			}
		}

		.scroll {
			// overflow-y: auto;
			// height: 55vh;
			// scrollbar-width: none;
			// -ms-overflow-style: none;

			.boxS {
				border-bottom: 1px solid #222630;
				padding: 20px;
				padding-bottom: 0;
				color: #888;

				.boxItem {
					display: flex;
					align-items: center;
					padding-bottom: 15px;


					div:nth-child(1) {
						width: 55%;
					}

					div:nth-child(2) {
						width: 45%;
						font-size: 13px;
					}
				}
			}
		}

		.switch {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 20px;
			color: #888;

			div {
				text-align: center;
			}

			.colost {
				color: #00f0ff;
			}
		}


		.boxTop {
			display: flex;
			padding-bottom: 25px;
			padding-top: 12px;

			.boxItem {
				width: 45%;

				.boxCode {
					font-size: 22px;
				}

				.boxAmount {
					padding: 15px 0;
					font-size: 15px;
				}

				.boxProportion {
					font-size: 12px;
				}
			}

			.boxItemS {
				width: 55%;
				color: #888;

				.boxText {
					display: flex;
					justify-content: space-between;
					padding-top: 4px;

				}
			}
		}


		.contentS {
			display: flex;
			justify-content: space-between;
			background: #000;
			padding: 15px;
			position: fixed;
			left: 0;
			right: 0;
			bottom: 60px;
			z-index: 88;
			border-top: 1px solid #181822;

			div {
				width: 47%;
				text-align: center;
				padding: 10px 0;
				border-radius: 10px;
				font-size: 16px;
			}

			div:nth-child(1) {
				background-color: #00f0ff;
				color: #000;
			}

			div:nth-child(2) {
				background-color: #ff4834;
			}
		}

	}
</style>